<template>
  <div class="newsletter__subscribe newsletter__subscribe_success">
    <header class="newsletter__header">{{ message }}</header>
    <close-button :on-close-callback="onClose" class="newsletter__btn_success">Luk</close-button>
  </div>
</template>

<script>
import CloseButton from '../components/CloseButton.vue'

export default {
    name: 'ResponseSuccessView',
    components: [CloseButton],
    data() {
        return {
            message: this.$root.config.response.success,
            onClose: this.$root.config.callback.onClose
        }
    }
}
</script>


// WEBPACK FOOTER //
// ResponseSuccessView.vue?ec6a5b04